var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProgrammer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    height: 512,
    viewBox: "0 0 60 60",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m48 49s-5-1-6-6v-1h-14v1c-1 5-6 6-6 6v1h26z",
    fill: "#b5bbc6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m59 37v3a3 3 0 0 1 -3 3h-37.65l-1.47-6 .12-1h41z",
    fill: "#ccd0da"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m59 4v33h-42.12l-5.88-23.95v-9.05a3 3 0 0 1 3-3h42a3 3 0 0 1 3 3z",
    fill: "#383838"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m15 13v-7a1 1 0 0 1 1-1h38a1 1 0 0 1 1 1v26a1 1 0 0 1 -1 1h-33z",
    fill: "#494949"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m21.35 49h29.65a1 1 0 0 1 1 1 3 3 0 0 1 -3 3h-23.34",
    fill: "#ccd0da"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m27 23v5l-8 8h-10l-8-8v-5a10 10 0 0 1 10-10h9.58a1.42 1.42 0 0 1 1.29 2 1.271 1.271 0 0 1 -.29.42l-1.58 1.58h1a6 6 0 0 1 6 6z",
    fill: "#80624b"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m11 42h6v7h-6z",
    fill: "#e2ac7f"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m5.471 29.884a9.67 9.67 0 0 0 17.058 0 4.139 4.139 0 0 0 .471-1.894 2 2 0 0 1 2-1.99 2 2 0 0 1 2 2v3a3 3 0 0 1 -3 3 10 10 0 0 1 -10 10 10 10 0 0 1 -10-10 3 3 0 0 1 -3-3v-3a2 2 0 0 1 2-2 2 2 0 0 1 2 1.99 4.139 4.139 0 0 0 .471 1.894z",
    fill: "#eebd91"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m17 48a10 10 0 0 1 10 10 1 1 0 0 1 -1 1h-24a1 1 0 0 1 -1-1 10 10 0 0 1 10-10z",
    fill: "#2783ec"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m21.87 15a1.271 1.271 0 0 1 -.29.42l-1.58 1.58h-4a1 1 0 0 1 0-2z",
    fill: "#725542"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m20 10h-1a1 1 0 0 1 0-2h1a1 1 0 0 1 0 2z",
    fill: "#f0f2f5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m39 10h-15a1 1 0 0 1 0-2h15a1 1 0 0 1 0 2z",
    fill: "#a696f0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m46 10h-3a1 1 0 0 1 0-2h3a1 1 0 0 1 0 2z",
    fill: "#3fdab1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m39 30h-8a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2z",
    fill: "#a696f0"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m46 30h-3a1 1 0 0 1 0-2h3a1 1 0 0 1 0 2z",
    fill: "#3fdab1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m33 14h-7a1 1 0 0 1 0-2h7a1 1 0 0 1 0 2z",
    fill: "#fccb55"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m33 18h-4a1 1 0 0 1 0-2h4a1 1 0 0 1 0 2z",
    fill: "#a696f0"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m40 14h-3a1 1 0 0 1 0-2h3a1 1 0 0 1 0 2z",
    fill: "#3fdab1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m35 26h-4a1 1 0 0 1 0-2h4a1 1 0 0 1 0 2z",
    fill: "#fccb55"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m40 22h-9a1 1 0 0 1 0-2h9a1 1 0 0 1 0 2z",
    fill: "#a696f0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m45 22h-1a1 1 0 0 1 0-2h1a1 1 0 0 1 0 2z",
    fill: "#3fdab1"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m60 53a1 1 0 0 1 -1 1h-32.84a9.278 9.278 0 0 0 -1.17-2h34.01a1 1 0 0 1 1 1z",
    fill: "#935d38"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgrammer);
export default __webpack_public_path__ + "static/media/programmer.5b9f1f8349cda65976c655241db6aea3.svg";
export { ForwardRef as ReactComponent };